/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportProceedingType
 */
export interface ReportProceedingType {
    /**
     * 
     * @type {object}
     * @memberof ReportProceedingType
     */
    details: object;
    /**
     * 
     * @type {object}
     * @memberof ReportProceedingType
     */
    sum: object;
}

export function ReportProceedingTypeFromJSON(json: any): ReportProceedingType {
    return ReportProceedingTypeFromJSONTyped(json, false);
}

export function ReportProceedingTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportProceedingType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': json['details'],
        'sum': json['sum'],
    };
}

export function ReportProceedingTypeToJSON(value?: ReportProceedingType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details,
        'sum': value.sum,
    };
}


